import { Nav } from "react-bootstrap";
import { NavLink, useParams, useLocation } from "react-router-dom";

export function AdminSidebarContent({
  onLinkClick,
}: {
  onLinkClick?: () => void;
}) {
  const { seasonId } = useParams();
  const location = useLocation();

  const isSeasonPage =
    location.pathname.includes("/admin/seasons/") && seasonId;

  return (
    <Nav className="flex-column admin-sidebar-nav">
      <div className="admin-nav-section">
        <div className="admin-nav-section-title">ADMIN</div>
        <Nav.Item>
          <NavLink to="/admin" end className="nav-link" onClick={onLinkClick}>
            <i className="bi-speedometer2 me-2"></i>
            Dashboard
          </NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink
            to="/admin/league-settings"
            className="nav-link"
            onClick={onLinkClick}
          >
            <i className="bi-gear me-2"></i>
            League Settings
          </NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink
            to="/admin/seasons"
            className="nav-link"
            onClick={onLinkClick}
          >
            <i className="bi-calendar-event me-2"></i>
            Seasons
          </NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink
            to="/admin/players"
            className="nav-link"
            onClick={onLinkClick}
          >
            <i className="bi-people me-2"></i>
            Players
          </NavLink>
        </Nav.Item>
        <Nav.Item>
          <NavLink to="/admin/users" className="nav-link" onClick={onLinkClick}>
            <i className="bi-person-badge me-2"></i>
            Users
          </NavLink>
        </Nav.Item>
      </div>

      {isSeasonPage && (
        <div className="admin-nav-section">
          <div className="admin-nav-section-title">SEASON {seasonId}</div>
          <Nav.Item>
            <NavLink
              to={`/admin/seasons/${seasonId}/overview`}
              className="nav-link"
              onClick={onLinkClick}
            >
              <i className="bi-card-text me-2"></i>
              Overview
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink
              to={`/admin/seasons/${seasonId}/teams`}
              className="nav-link"
              onClick={onLinkClick}
            >
              <i className="bi-people-fill me-2"></i>
              Teams & Players
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink
              to={`/admin/seasons/${seasonId}/schedules`}
              className="nav-link"
              onClick={onLinkClick}
            >
              <i className="bi-calendar3 me-2"></i>
              Schedule
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink
              to={`/admin/seasons/${seasonId}/scores`}
              className="nav-link"
              onClick={onLinkClick}
            >
              <i className="bi-trophy me-2"></i>
              Scores & Stats
            </NavLink>
          </Nav.Item>
        </div>
      )}
    </Nav>
  );
}

function AdminNav() {
  return (
    <div className="admin-sidebar d-none d-md-block">
      <AdminSidebarContent />
    </div>
  );
}

export default AdminNav;
